module.exports = __webpack_public_path__ + "img/kantoor-werk.cf37124c.jpeg";